import React from 'react'
import { Controller, useFormState } from 'react-hook-form'
import { Switch } from 'antd'
import styles from './SwitchField.module.css'

const ActiveSwitchField = ({ field, control }) => {
  const { errors, isSubmitted } = useFormState({ control })
  const error = errors[field.idFieldCanvas]
  let switchClass = ''

  if (isSubmitted) {
    switchClass = error ? 'input-error' : 'input-success'
  }

  const input_style = field.input_design ? { ...field.input_design } : {}

  const SwitchRender = ({ onChange = () => {}, value }) => (
    <div style={input_style} className={`${styles.switch} ${switchClass}`}>
      <Switch checked={value} onChange={onChange} />
    </div>
  )

  const defaultValue =
    field.VALUE__reponse !== undefined ? field.VALUE__reponse : false

  return (
    <Controller
      control={control}
      name={field.idFieldCanvas}
      rules={{ required: field.required }}
      render={({ field: { onChange, value } }) => (
        <SwitchRender onChange={onChange} value={value} />
      )}
      defaultValue={defaultValue}
    />
  )
}

const InactiveSwitchField = ({ field }) => {
  const input_style = field.input_design ? { ...field.input_design } : {}

  const SwitchRender = () => (
    <div style={input_style} className={styles.switch}>
      <Switch defaultChecked={false} />
    </div>
  )

  return <SwitchRender />
}

const SwitchField = ({ field, control, isActiveSubmit }) => {
  return isActiveSubmit ? (
    <ActiveSwitchField field={field} control={control} />
  ) : (
    <InactiveSwitchField field={field} />
  )
}

export default SwitchField
